//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.ShippingMethodId
import com.tixforgigs.apax.models.ShoppingCart

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The cart refresh request model
* 
* @param countryCode The country of the user
* @param shoppingCart 
* @param shippingMethodId 
*/
@Serializable

data class CartRefreshRequest (


      /* The country of the user */
    @SerialName(value = "countryCode") @Required val countryCode: kotlin.String,


      @SerialName(value = "shoppingCart") @Required val shoppingCart: ShoppingCart,


      @SerialName(value = "shippingMethodId") val shippingMethodId: ShippingMethodId? = null


) {




  }

